module.exports = "/assets/d021d5c569e4f7e858f9139e7d5de058.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/B7.png
// module id = 1220
// module chunks = 0